module.exports = __webpack_public_path__ + "9581219ef6425527910c295837d94d59.svg";